export default "__VITE_ASSET__e840f0ad__"